@switch (message.status) {
  @case ('expired') {
    <div
      class="voice-wrapper voice-wrapper--expired border-radius-pill t-7@r font-style-italic color-ash border"
      [ngClass]="{ 'cursor-pointer': !message.is_me }"
      (click)="onExpiredVoiceMessageClick(message)"
    >
      <sb-icon class="color-cloud" [name]="'clock'" [size]="'7'" />
      Voice message expired
    </div>
  }

  @case ('locked') {
    <div class="voice-wrapper voice-wrapper--locked pf-4 bg-jet border-radius-16 display-flex flex-direction-column">
      <div class="display-flex justify-content-space-between align-items-center mb-4">
        <sb-stamp [size]="'small'" [type]="'fill-semi-transparent-white'">
          <sb-icon [name]="'lock'" />
        </sb-stamp>
        <sb-voice-message-progress-bar class="mh-2" [progress]="0" [theme]="'locked'" />
        <div class="t-8@r font-weight-500 color-white">
          {{ message.voice_message.duration * 1000 | date: 'm:ss' }}
        </div>
      </div>
      <div class="display-flex justify-content-space-between">
        <div class="display-flex flex-direction-column justify-content-flex-end font-weight-500">
          @let expiresIn = (message.voice_message.expires_at | expiryTimer: [12 * Timespan.Hour]) ?? 0;
          <div
            class="t-11@r font-weight-500 text-transform-uppercase letter-spacing-0.06"
            [ngClass]="{
              'color-red': expiresIn < 12 * Timespan.Hour,
              'color-orange': expiresIn >= 12 * Timespan.Hour && expiresIn < 24 * Timespan.Hour,
              'color-white': expiresIn >= 24 * Timespan.Hour,
            }"
          >
            Expires in
          </div>
          <div class="t-10@r color-white">
            {{ (message.voice_message.expires_at | expiryTimer)! | parseMs: '(hh)h : (mm)m : (ss)s' }}
          </div>
        </div>
        <button
          class="white-space-nowrap"
          sbButton
          [processing]="message.unlockInProgress ?? false"
          [variant]="'fill-gold'"
          (click)="conversationStore.attemptToUnlockVoiceMessage(message, conversation)"
        >
          Unlock
        </button>
      </div>
    </div>
  }

  @case ('viewable') {
    <div
      class="voice-wrapper voice-wrapper--viewable border-radius-pill"
      [ngClass]="message.is_me ? 'voice-wrapper--sent' : 'voice-wrapper--received'"
    >
      <sb-voice-message-player
        [message]="message"
        [theme]="message.is_me ? 'light' : 'dark'"
        (playVoiceMessage)="
          conversationStore.playVoiceMessage({ message, profile_browse_id: conversation.profile.browse_id })
        "
      />
    </div>
  }
}
